
define('directives/consoleApi/project.head',['app'], function (app) {
    app.directive('projectHead', ['$state','projectManageService','ngDialog', '$stateParams','$timeout','auiDialog','$q',
        function ($state,projectManageService,ngDialog,$stateParams,$timeout,auiDialog,$q) {
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: 'directives/consoleApi/project.head.html',
            link: function ($scope, $element, attrs, ngModelCtrl) {
                var Model = $scope.Model;
                Model.projectKey= $stateParams.projectKey;
                $scope.managerPro =managerPro;
                function managerPro() {
                    projectManageService.getProjectTotalCount().then(function (projectTotalCount) {
                        Model.ProjectTotalCount = projectTotalCount;
                        projectManageService.managerPro(attrs,$stateParams,Model);
                    });
                }
            }
        }
    }]);
});

